import React, { Component } from 'react';
import { connect } from "react-redux";

import { constants } from '../../../../../Helpers/Constants';
import { goSurvey } from '../../../../../Actions/dataActions';
import EmptyState from '../../../../Common/EmptyState';
import { ViewSurvey } from '../../../../Common/Buttons/Icons';
import { Trans } from 'react-i18next';
import { GridContainer, GridItem } from '../../../../Common/DesignSystem/Grid';
import { Tabs, TabItem } from '../../../../Common/DesignSystem/Tabs';
import Icon from '../../../../Common/DesignSystem/Icons/Icon';
import colours from '../../../../Common/DesignSystem/Colours';
import Chip from '../../../../Common/DesignSystem/Chips';
import { P3Bold } from '../../../../Common/DesignSystem/Text';
import Button from '../../../../Common/DesignSystem/Button';
import SurveyDetails from './SurveyDetails';
import {LoadingIconRow} from '../.././../../Common/Loading_Icon';

class ProfileSurveysTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFilter: 'All',
            showDetails: null,
            sentSurveys: [],
            completedSurveys: [],
            loading: true,
        };

        this.renderTable = this.renderTable.bind(this);
    }

    componentDidMount() {
        var keys = Object.keys(this.props.profile_details.surveys)
        var data = this.props.profile_details.surveys;

        let completed = [];
        let sent = [];

        keys.map((survey, index) => {
            if (data['' + survey].completed_date) {
                completed.push({name: survey, data: data['' + survey]});
            } else {
                sent.push({name: survey, data: data['' + survey]});
            }
        });

        this.setState({sentSurveys: sent, completedSurveys: completed, loading: false});
    }

    renderTable() {
        let surveys = [];
        if (this.state.selectedFilter === 'Completed') {
            surveys = this.state.completedSurveys;
        } else if (this.state.selectedFilter === 'Sent') {
            surveys = this.state.sentSurveys;
        } else {
            surveys = this.state.completedSurveys.concat(this.state.sentSurveys);
        }

        if (surveys && surveys.length === 0) {
            return(
                <tr>
                    <td colSpan = '5'><EmptyState image="media-emptystate.svg" text="No Surveys" /></td>
                </tr>
            )
        } else {
            return(
                surveys.map((survey, index) => {
                    return (
                        <tr className="ds-booking-row no-border" key={survey.name} style={{backgroundColor: index % 2 !== 0 ? '#F4F6F8' : 'white'}} onClick={()=>{this.setState({showDetails: survey})}}>
                            <td label="Status" className="align-center" style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                                {survey.data.completed_date ? 
                                    <Chip custom={{backgroundColor: colours.accent.validate_green, fontColor: '#FFF', label: 'Completed'}}/> 
                                    : <Chip type="sent"/>
                                }
                            </td>
                            <td label="Survey Type" className="align-left">
                                <P3Bold>{survey.name}</P3Bold>
                            </td>
                            <td label="Sent" className="align-center">
                                <P3Bold>{survey.data.created_date}</P3Bold>
                            </td>
                            <td label="Completed" className="align-center">
                                <P3Bold>{survey.data.completed_date}</P3Bold>
                            </td >
                            <td label="Actions" className="align-center">
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                                    <Button label="Resend" leading_ic="Refresh" secondary small onClick={()=>{}} disabled={survey.data.completed_date}/>
                                </div>
                            </td>
                        </tr>
                    )
                })
            )
        }
    }

    render(props) {
        var keys = Object.keys(this.props.profile_details.surveys);
        var objects = this.props.profile_details.surveys[keys[0]];

        return(
            <div className="row expanded bkg-white-dark">
                <div className="columns large-12 medium-12 small-12">
                    <GridContainer justifyContent='space-evenly' direction={this.state.windowWidth <= 768 ? "column" : "row"}>
                        <GridItem xs={12}>
                            <div className="ds-card">
                                <Tabs value={this.state.selectedFilter} onChange={(e) => {this.setState({selectedFilter: e.currentTarget.dataset.id})}}>
                                    <TabItem label="All"/>
                                    <TabItem label="Sent"/>
                                    <TabItem label="Completed"/>
                                </Tabs>
                                <table className = "ds-table" style={{marginTop: 16}}>
                                    <thead>
                                        <tr className = "table-header">
                                            <th style = {{width: "120px"}} className={"align-center"}>
                                                <Trans>Status</Trans>
                                            </th>
                                            <th className={"align-left"}>
                                                <Trans>Survey Type</Trans>
                                            </th>
                                            <th style={{width: '160px'}} className={"align-center"}>
                                                <Trans>Sent</Trans>
                                            </th>
                                            <th style={{width: '160px'}} className={"align-center"}>
                                                <Trans>Completed</Trans>
                                            </th>
                                            <th style={{width: '100px'}} className="align-center">
                                                <Trans>Actions</Trans>
                                            </th>
                                        </tr>
                                    </thead>
                                    {
                                        this.state.loading ?
                                        <tbody>
                                            {LoadingIconRow(5)}
                                        </tbody> : 
                                        <tbody className="ds-booking-row" >
                                            {this.renderTable()}
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
                {this.state.showDetails ? <SurveyDetails details={this.state.showDetails} closeModal={()=>{this.setState({showDetails: null})}}/> : null}
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(ProfileSurveysTab)